import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { LicenseDialogMessagesEnum } from '../enums/toastr-messages/license-dialog-messages.enum';
import { LicenseStatusModel } from '../models/view-models/license-models/license-status.model';
import { LicenseService } from '../services/http-services/license.service';

@Injectable()
export class LicenseGuard  {

  constructor(
    private readonly licenseService: LicenseService,
    private readonly router: Router,
    private readonly toastrService: ToastrService
  ) { }

  canActivate(): Observable<boolean> | boolean {
    if (this.licenseService.isNavigateToAdmin) {
      this.checkUserAccessibility(false).subscribe();
      return true;
    }
    return this.checkUserAccessibility();
  }

  private checkUserAccessibility(isStatusInPending: boolean = true): Observable<boolean> {
    this.licenseService.isNavigateToAdmin = false;
    this.licenseService.isStatusInPending.next(isStatusInPending);

    if (this.licenseService.licenseStatusModel) {
      return of(this.checkStatusForGuard(this.licenseService.licenseStatusModel));
    } else {
      return this.licenseService.licenseStatusModel$.pipe(
        filter((licenseModel: LicenseStatusModel) => !!licenseModel),
        take(1),
        map((licenseModel: LicenseStatusModel) => {
          this.licenseService.licenseStatusModel$.next(licenseModel);
          this.licenseService.licenseStatusModel = licenseModel;
          this.licenseService.isStatusInPending.next(false);
          return this.checkStatusForGuard(licenseModel);
        })
      );
    }
  }

  private checkStatusForGuard(licenseModel: LicenseStatusModel): boolean {
    this.licenseService.isStatusInPending.next(false);
    if (!licenseModel || !licenseModel.Status) {
      setTimeout(() => {
        this.router.navigateByUrl('/Forbidden');
      });
      this.toastrService.error(
        LicenseDialogMessagesEnum.LicenseGuargMainMessage, LicenseDialogMessagesEnum.LicenseGuargTitle);
      return false;
    }

    return true;
  }
}
